import { getTime } from '../utils/formaters';
export const LogDtoToLog = (item, type) => {
    const commonItens = [
        { name: 'Data', value: getTime(item.DataHora, 'date') || 'Indisponível' },
        {
            name: 'Horário',
            value: getTime(item.DataHora, 'time') || 'Indisponível',
        },
        { name: 'Nome do usuário', value: item.NomeUsuario || 'Indisponível' },
        { name: 'Ação', value: item.AcaoRealizada || 'Indisponível' },
        { name: 'Seção acessada', value: item.SecaoAcessada || 'Indisponível' },
        { name: 'Status', value: item.Sucesso ? 'Sucesso' : 'Erro' },
    ];
    switch (type) {
        case 'financial':
            return [
                ...commonItens,
                { name: 'Anexo id', value: item.AnexoId || 'Indisponível' },
                { name: 'Medição id', value: item.MedicaoId || 'Indisponível' },
                { name: 'Centro de custo', value: item.CostCenter || 'Indisponível' },
            ];
        case 'faq':
            return [
                ...commonItens,
                { name: 'Id', value: item.ItemAlteradoId || 'Indisponível' },
                { name: 'Descrição', value: item.Descricao || 'Indisponível' },
            ];
        case 'schedule':
            return [
                ...commonItens,
                { name: 'Id', value: item.AgendamentoId || 'Indisponível' },
                {
                    name: 'Data do agendamento',
                    value: item.DataAgendamento || 'Indisponível',
                },
                { name: 'Placa', value: item.Placa || 'Indisponível' },
                { name: 'Base', value: item.Base || 'Indisponível' },
            ];
        default:
            return commonItens;
    }
};
const logItemDtoToLogItem = (items) => {
    return items.map(dto => ({
        id: dto.Id || '-',
        time: getTime(dto.DataHora, 'time') || '-',
        date: getTime(dto.DataHora, 'date') || '-',
        username: dto.NomeUsuario || '-',
        action: dto.AcaoRealizada || '-',
        section: dto.SecaoAcessada || '-',
        success: dto.Sucesso,
    }));
};
export const LogsDtoToLogs = (tableLogs) => ({
    itens: logItemDtoToLogItem(tableLogs.Data),
    pageCount: tableLogs.TotalPaginas,
    rows: tableLogs.TotalTamanho,
});
